export class DiscountCodeModel {
    public discountCodeId: string;
    public code: string;
    public minimumPurchase: number;
    public discountRate: number;
    public maximumAmount: number;
}
